$( document ).ready(function() {
  if (window.location.href.indexOf("/tools/recurring/customers") > -1) {
  if (window.location.href.indexOf("/edit") > -1) {
    $("label[for='shipping_address_2']").text("Apt, suite, etc.");
    $("label[for='billing_address_2']").text("Apt, suite, etc.");
    $.ajax({
  url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyBQN_f1397054ReMn1ybjxGl1TXhKXTB08&libraries=places&callback=initMap",
  dataType: "script"
});  

  	//$('#billing_phone').attr('pattern', '[0-9][0-9]{9}');
    //$('#billing_phone').mask('(00) 000-0000');
	//console.log('Account Edit Pages Only');


function initMap() {

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("billing_address_1"));
    autocomplete.setComponentRestrictions({'country': 'NZ'});    

        autocomplete.addListener('place_changed', function() {

          var place = autocomplete.getPlace();

          $("#billing_address_1").val(place.name);
          // Get each component of the address from the place details
          // and fill the corresponding field on the form.
          for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            var value = place.address_components[i].long_name;

            if (addressType=="locality") {
              $("#billing_city").val(value);
            } else if (addressType=="country") {
              $("#checkout_shipping_address_country").val(value);
              triggerManualEvent(document.getElementById('checkout_shipping_address_country'), 'change');
              for (var s = 0; s < place.address_components.length; s++) {
                if (place.address_components[s].types[0]=="administrative_area_level_1") {
                  $("#billing_city").val(place.address_components[s].long_name);
                }
              }
            } else if (addressType=="postal_code") {
              $("#billing_postalcode").val(value);
            }
          }

        });
}
  }
      }
});



    function triggerManualEvent(element, eventName) {
        if (document.createEvent)
        {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent(eventName, true, true);

            return element.dispatchEvent(evt);
        }

        if (element.fireEvent)
            return element.fireEvent('on' + eventName);
    }

// Delivery Schedule Calculation
$( document ).ready(function() {
  if (window.location.href.indexOf("/order_schedule") > -1) {
    $('.rc__schedule__orders__order__date').each(function() {
      var dateString = $(this).html();
      dateString = dateString.replace("<strong>","");
      dateString = dateString.replace("</strong>","");
      var dateString = dateString.split(" ");
      dateString[0] = dateString[0].trim();
      dateString[1] = dateString[1].replace(",","");
      dateString[2] = dateString[2].trim();
      /*console.log("Month ->" + dateString[0]);
      console.log("Date ->" + dateString[1]);
      console.log("Year ->" + dateString[2]);*/

      var newdate = (moment().date(dateString[1]).month(dateString[0]).year(dateString[2]).add(7, 'days').format("MMMM DD, YYYY"));

      $(this).html(newdate);

    });
    $('.rc_schedule__order__address').remove();
    $('.rc_visible_xs').remove();
    $('.rc_text--right').remove();
    $('.rc_text--center').remove();
    $('td:nth-child(3)').remove();
    var stylesheet = "//cdn.shopify.com/s/files/1/0044/1296/4979/t/5/assets/delivery-schedule.css?v=45507398941873488641538100774";
	$('head').append('<link rel="stylesheet" type="text/css" href="' + stylesheet + '">');
  }
  
    if (window.location.href.indexOf("/account") > -1) {
      var stylesheet = "//cdn.shopify.com/s/files/1/0044/1296/4979/t/5/assets/billing-info.css?v=160163796666259567801538100773";
      	$('head').append('<link rel="stylesheet" type="text/css" href="' + stylesheet + '">');
}
  if (window.location.href.indexOf("/subscription") > -1) {
  var subtitle = $('.td-product').text();
    var chargedate = $('.td-next-charge-date').text();
    var editbutton = $('.rc_subscriptions__subscription__item__edit').html();
    var cancelbutton = $('.rc_subscriptions__subscription__item__cancel').html();
    //$("<h4>"+subtitle+"</h4><p>Next biling date,"+chargedate+"</p><span class='rc_subscriptions__subscription__item__edit'>"+editbutton+"</span>").insertBefore('.purchase-address');
    //$('.td-product').remove();
    //$('#hidden-header-ReCharge').remove();
    console.log(editbutton);
  }
});